import { system, LookupStorage } from "portalframework";
import * as ko from "knockout";
import * as $ from "jquery";
import * as _ from "lodash";
import * as entitiesE from "entitiesE";
import { attachment_wrapper, warranty_request, request_dto, productExtended, RequestSearchCriteria } from "organized";
import labels from "app/labels";
import { AttachmentResultDTO, downloadAttachmentFromBase64 } from "services";
import { portalHttpService } from "./_common/httpService";
import * as toastr from "toastr";
import { BaseService } from "./_common/_baseService";

class WarrantyService extends BaseService {
  constructor() {
    super("warranty");
  }

  public getWarrantyCreateScreenData = async (): Promise<void> => {
    let requiredLookups = ["C_PHENOMENON_CLASS", "C_PHENOMENOM_CODE", "C_WTY_CLAIM_STATUS", "WTY_COV_TYPE"];
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let payload = ko.toJSON({ requiredLookups: lookupsToFetch });

    const results = await portalHttpService.post<any>(`${this.baseApiUrl()}/WarrantyCreateScreenData`, payload);

    lookupsToFetch.forEach((lookupName) => {
      const list = results[lookupName];
      if (list) {
        if (lookupName == "PLACEPERSONS") {
          if (!Array.isArray(list.person)) {
            list["placepersons"] = [list["person"]];
          } else {
            list["placepersons"] = list["person"];
          }
          delete list["person"];
          _.each(list.placepersons, (p) => {
            p.description = p.first_name + " " + p.last_name;
            p.placepersons = p.person_id;
          });
        }
        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
  };

  public getWarrantyRequestById = async (request_id: string): Promise<warranty_request> => {
    const warrantyResult = await portalHttpService.get<any>(
      `${system.apiURL()}api/${this.controllerName}/GetWarrantyRequestById/${request_id}`,
    );
    let request = new warranty_request(warrantyResult);
    if (request) {
      return request;
    }

    throw new Error(labels.descr("c_No_Item_Access"));
  };

  public searchProduct = async (serial_id: string): Promise<productExtended> => {
    const productsFound = await portalHttpService.post<any[]>(
      `${this.baseApiUrl()}/SearchProduct`,
      ko.toJSON({ serial_id: serial_id }),
    );
    if (productsFound && productsFound.length === 1) {
      return new productExtended(productsFound[0]);
    } else {
      throw new Error(labels.descr("cc_P_NO_SERIAL_FOUND"));
    }
  };

  saveWarrantyFields = async (
    request_id: string,
    result: { repair_date: string; own_reference: string; repair_report: string },
  ): Promise<void> => {
    await portalHttpService.post(`${this.baseApiUrl()}/saveWarrantyFields?request_id=${request_id}`, ko.toJSON(result));
  };

  public saveDefectivePart = async (
    defectivePart: entitiesE.warranty_defective_part,
  ): Promise<entitiesE.warranty_defective_part> => {
    var data = ko.toJS(defectivePart);

    const result = await portalHttpService.post<any>(
      system.apiURL() + "api/warranty/saveDefectivePart",
      ko.toJSON(data),
    );
    let savedDefectivePart = new entitiesE.warranty_defective_part(result.results.c_wty_claim_defective_part);
    return savedDefectivePart;
  };

  public deleteDefectivePart = async (defectivePart: entitiesE.warranty_defective_part): Promise<void> => {
    var data = ko.toJS({
      request_id: defectivePart.request_id(),
      request_unit_id: defectivePart.request_unit_id(),
      sequence: defectivePart.sequence(),
    });

    await portalHttpService.post<any>(system.apiURL() + "api/warranty/deleteDefectivePart", ko.toJSON(data));
  };
  public saveMaintenanceKit = async (
    kit: entitiesE.warranty_mk,
    request_id: string,
  ): Promise<entitiesE.warranty_mk> => {
    const data = await portalHttpService.post<any>(
      `${this.baseApiUrl()}/saveMaintenanceKit?request_id=${request_id}`,
      ko.toJSON(ko.toJS(kit)),
    );
    let savedKit = new entitiesE.warranty_mk(data.results.c_mk_to_product);
    return savedKit;
  };

  public GetMKitsForRequest = async (request_id: string, serial_id: string) => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetMKitsForRequest`);
    myUrlWithParams.searchParams.append("request_id", request_id);
    myUrlWithParams.searchParams.append("serial_id", serial_id);
    const result = await portalHttpService.get<{ default_kits: any[]; request_kits: any[] }>(myUrlWithParams.href);

    return {
      default_kits: result.default_kits.map((kit) => new entitiesE.warranty_mk(kit)),
      request_kits: result.request_kits.map((kit) => new entitiesE.warranty_mk(kit)),
    };
  };

  public genPhenomenomCodesForPartId = async (partId: string) => {
    return await portalHttpService.get<string[]>(`${this.baseApiUrl()}/GenPhenomenomCodesForPartId/${partId}`);
  };

  public updateCounter = async (request: request_dto): Promise<void> => {
    var data = ko.toJS(request);
    await portalHttpService.post(system.apiURL() + "api/request/UpdateCountersTab", ko.toJSON(data));
  };

  public saveRequest = async (request: warranty_request): Promise<void> => {
    const data1 = ko.toJS(request);
    delete data1.request_attachment;

    const result = await portalHttpService.post<any>(`${this.baseApiUrl()}/saveRequest`, ko.toJSON(data1));

    if (!request.request_id() && result.request.request_id) {
      request.request_id(result.request.request_id);
    }

    if (result.hasError) {
      throw result.exception;
    }
    let user_def3 = "SPAREPART";
    //#region  Last minute patching cuz why not
    if (window.location.href.includes("device_wty_claim")) {
      user_def3 = "DEVICE";
      request.mergeFromJS(result.request);
    }
    if (window.location.href.includes("part_dev_wty_claim")) {
      request.mergeFromJS(result.request);
    }
    if (!request.user_def3()) {
      request.user_def3(user_def3);
    }
    //#endregion
  };

  public resubmitRequest = async (request_id: string, user_def10: string = "", ext_portal_req_subtype: string = "") => {
    await portalHttpService.post(
      `${this.baseApiUrl()}/UpdateRequest`,
      ko.toJSON({ request_id, user_def10, ext_portal_req_subtype }),
    );
    toastr.success(labels.descr("cc_Warranty_Request_Resubmitted"));
  };

  public exportFile = async (
    criteria: RequestSearchCriteria,
    headers: { label: string; css: KnockoutComputed<string>; sortMe: () => void }[],
    offset: any,
  ): Promise<void> => {
    const labelsResult = headers.map((header) => header.label).join(",");
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/ExportFile/`);
    myUrlWithParams.searchParams.append("criteria", ko.toJSON(criteria));
    myUrlWithParams.searchParams.append("labelsString", labelsResult);
    myUrlWithParams.searchParams.append("timeZone", `${offset}`);

    const fileResult = await portalHttpService.get<AttachmentResultDTO>(myUrlWithParams.href);
    downloadAttachmentFromBase64(fileResult);
  };
}

export const warrantyService = new WarrantyService();
